import { resetStateMetaReducer } from '@common/data-access-shared';

import { localStorageSyncReducer } from './session-storage-sync.reducer';

export const META_REDUCERS = [localStorageSyncReducer, resetStateMetaReducer];
